export default "__VITE_ASSET__5152647e__"